import { forwardRef, PropsWithChildren, RefObject } from 'react';

import { Tooltip } from '@src/components/Tooltip';

import { ButtonWrapper } from './styles';
import { BaseButtonProps } from './types';

const ButtonBase = forwardRef<HTMLElement, PropsWithChildren<BaseButtonProps>>(
  (props, ref) => {
    const {
      as,
      children,
      width,
      height,
      dataTestId,
      ariaLabel,
      ariaPressed,
      theme,
      tabIndex,
      tooltip,
      ...rest
    } = props;
    const buttonTheme = { ...theme, width, height };

    const content = (
      <ButtonWrapper
        {...rest}
        ref={ref as RefObject<HTMLButtonElement>}
        aria-label={ariaLabel}
        aria-pressed={ariaPressed}
        as={as}
        data-testid={dataTestId}
        role={as ? (as === 'a' ? 'link' : 'button') : undefined}
        tabIndex={tabIndex ?? 0}
        theme={buttonTheme}
      >
        {children}
      </ButtonWrapper>
    );

    return tooltip ? <Tooltip {...tooltip}>{content}</Tooltip> : content;
  }
);

ButtonBase.displayName = 'ButtonBase';

export default ButtonBase;
